// extracted by mini-css-extract-plugin
export var headDescr = "form-module--headDescr--SR-YS";
export var headTitle = "form-module--headTitle--lUro8";
export var innerWrapperForm = "form-module--innerWrapperForm--GadD+";
export var section = "form-module--section--HSNRS";
export var textBlock = "form-module--textBlock--Jal1U";
export var wrapperForm = "form-module--wrapperForm--gonSA";